import { Card, CardHeader, Grid } from '@mui/material';

export default function Page_Resume() {
  const pageStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  };

  return (
    <Grid container>
        <Grid size={12} item>

        </Grid>
    </Grid>
  );
}